export default "__VITE_ASSET__Bp02wDHa__"